enum MaturityTypes {
    'P' = "P - Perpetual",
    'Q' = "Q - Perpetual with call feature",
    'R' = "R - Perpetual with put feature",
}

export default MaturityTypes;
